export default (dc, { defaultModel, defaultView, ...config }) => {
  const type = 'accordion-header'
  const attrKey = config.attrAccordionHeader
  const classKey = config.classAccordionHeader

  dc.addType(type, {
    model: defaultModel.extend({
      defaults: {
        ...defaultModel.prototype.defaults,
        name: 'Accordion Header',
        draggable: false,
        copyable: false,
        removable: false,
        ...config.accordionHeaderProps
      },

      init() {
        const attrs = this.getAttributes()
        attrs[attrKey] = 1
        this.setAttributes(attrs)
        classKey && this.addClass(classKey)
      }
    }, {
      isComponent(el) {
        if (el.hasAttribute && el.hasAttribute(attrKey)) {
          return { type }
        }
      }
    }),
    view: defaultView
  })
}
